var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickTock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.12 18.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b8d2d3",
    d: "M16.12,7.62a3.55,3.55,0,0,1-.46,0,5,5,0,0,1-4.21-2.28v7.75A5.73,5.73,0,1,1,5.72,7.39l.36,0v2.82c-.12,0-.23,0-.36,0a2.92,2.92,0,1,0,0,5.84,3,3,0,0,0,3-2.89L8.79,0h2.7a5,5,0,0,0,4.63,4.49V7.62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickTock);
export default __webpack_public_path__ + "static/media/tick-tock.e47d2eee16c06062082eb723a221b580.svg";
export { ForwardRef as ReactComponent };